import React from 'react'
import Footer from '../Components/Footer'
import HeroImage from '../Components/HeroImage'
import Form from '../Components/Form'

const Contact = () => {
  return (
    <>
    <HeroImage heading="CONTACT." text="Let's Have A Chat"/>
    <Form/>
    <Footer/>
    </>
  )
}

export default Contact
